import React from 'react'
import { Doughnut } from 'react-chartjs-2'
import styled from 'styled-components';
import i18n from '../i18n';

const placeData = (data) => {
  const { working_hours_count_month, working_hours_goal_month } = data;
  const monthCount = working_hours_count_month
  const monthGoal = working_hours_goal_month
  const monthLeft = +monthGoal - +monthCount

  return ({
    labels: [i18n.t('workingHours.current'), i18n.t('workingHours.left')],
    datasets: [
      {
        data: [+monthCount, monthLeft],
        backgroundColor: ['#47D789', '#A0A0A0'],
      },
    ],
  })
};

const WorkingHoursGoal = (props) => {
  const { data } = props;

  return (
    <Container>
      <Header>
        <h5>{i18n.t('workingHours.title')}</h5>
      </Header>
      <Doughnut data={placeData(data)} />
    </Container>
  )
};

export default WorkingHoursGoal;

const Container = styled.div`
  position: relative;
  width: 100%;
`;

const Header = styled.div`
  text-align: center;
`;
